import React, { useRef, useEffect, useContext } from "react";
import { RadioContext } from "../../services/RadioProvider";
import usePlayerUtils from "../../hooks/usePlayerUtils";
import useSyncedTrack from "../../services/useSyncedTrack";
import "./RadioPlayerCoverFrame.css";

export default function RadioPlayerCoverFrame() {
  const { nowPlaying } = useContext(RadioContext);
  const {
    currentTrack: listeningTrack,
    audioTimeMs,
    playbackState,
  } = usePlayerUtils();
  const coverRef = useRef(null);

  const coverEffects = ["d-fade", "d-slide", "d-zoom"];
  const getRandomEffect = () => coverEffects[Math.floor(Math.random() * coverEffects.length)];

  const syncedTrack = useSyncedTrack(nowPlaying, audioTimeMs, playbackState);
  const liveTrack = syncedTrack || nowPlaying?.history?.[0] || null;

  const isActive = playbackState === "playing" || playbackState === "paused";
  const currentTrack = isActive ? (listeningTrack || liveTrack) : liveTrack;

  useEffect(() => {
    if (coverRef.current && currentTrack?.coverUrl) {
      coverRef.current.className = "d-cover " + getRandomEffect();
    }
  }, [currentTrack?.coverUrl]);

  const artist = currentTrack?.artist || "";
  const songTitle = currentTrack?.title || "";
  const coverUrl = currentTrack?.coverUrl || "";
  const duration = currentTrack?.duration || "";

  const modifiedCoverUrl = coverUrl.includes("default")
    ? coverUrl.replace(".png", "-mid.png")
    : coverUrl;

  return (
    <div className="d-frame-main">
      <div className="d-title-info">
        <div className="d-text"></div>
      </div>
      <div className="d-outer-frame">
        <div className="d-cover-frame">
          <div className="d-cover-inner">
            <div id="d-frame" style={{ backgroundImage: `url(${modifiedCoverUrl})` }}></div>
            {coverUrl && <img ref={coverRef} className="d-cover d-fade" src={modifiedCoverUrl} alt="Cover" />}
          </div>

          <div className="d-title">
            <div className="underline"></div>
            <div className="d-title-main">
              <div className="d-title-main-inner">
                <div className="d-title-title">{songTitle}</div>
                <div className="d-title-artist">{artist}</div>
              </div>
              <div className="d-title-duradion"><div className="d-title-duradion-text">{duration}</div></div>
            </div>
            <div className="underline"></div>
          </div>
        </div>
      </div>
    </div>
  );
}